import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_GetCurrentFinancialPlan, API_GetProposedFinancialPlan, BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api';
import config from '../../config';
import { StageDCurrentFinancialPlan } from '../../models/classes/stage-d/Review-Application.class';

const isProd =
  process.env.NODE_ENV === 'production' &&
  document.location.origin !== 'https://services3-dev.hdb.gov.sg' &&
  document.location.origin !== 'https://services3-stg.hdb.gov.sg';

interface QueryParams {
  uinfin: string;
  singpass_token: string;
  application_id: string;
}
export const financialPlanApi = createApi({
  reducerPath: 'financialPlanApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers) => {
      return headers;
    },
  }),
  keepUnusedDataFor: 3,
  endpoints: (builder) => ({
    getCurrentFinancialPlanData: builder.query<StageDCurrentFinancialPlan, QueryParams>({
      query: ({ application_id, uinfin, singpass_token }) => ({
        url: API_GetCurrentFinancialPlan,
        method: 'GET',
        params: { application_uuid: application_id },
        headers: {
          Authorization: `Bearer ${singpass_token}`,
          ...(isProd ? {} : { uinfin }),
        },
      }),
    }),
    getProposedFinancialPlanData: builder.query<StageDCurrentFinancialPlan, QueryParams>({
      query: ({ application_id, uinfin, singpass_token }) => ({
        url: API_GetProposedFinancialPlan,
        method: 'GET',
        params: { application_uuid: application_id },
        headers: {
          Authorization: `Bearer ${singpass_token}`,
          ...(isProd ? {} : { uinfin }),
        },
      }),
    }),
  }),
});

export const { useGetCurrentFinancialPlanDataQuery, useGetProposedFinancialPlanDataQuery } = financialPlanApi;
